import React, { Fragment, useState } from 'react';
import XLSX from 'xlsx';
import styled from 'styled-components';
import toast from '~~elements/Toast';
import Button from '~~elements/Button';
import Input from '~~elements/Input';
import { parseExcel, getBoxScore } from '~~services/PbPExcel';
import { updateGamePbP } from '../service';
import { useTournamentDispatch, useTournamentState } from '../useTournament';

const StyledDiv = styled.div`
  display: flex;
  flex-wrap: wrap;
  padding: 0.5rem 0;
  > button,
  input {
    margin-right: 1rem;
  }
`;

const PbPUpload = ({ awayTeamPlayers, homeTeamPlayers, gameWithPlayers }) => {
  const tournamentDispatch = useTournamentDispatch();
  const { tournamentInfo } = useTournamentState();

  const [parsedData, setParsedData] = useState(null);
  const [endOuts, setEndOuts] = useState('3');
  const [uploading, setUploading] = useState(false);

  const [inputRefresh, setInputRefresh] = useState(0);

  const errorToast = (message) => {
    toast(message, {
      status: 'error',
      second: 3,
    });
    setInputRefresh((pre) => ++pre);
  };

  const handleEndOutsChange = (e) => {
    setEndOuts(e.target.value);
  };

  const handleFileOnChange = (e) => {
    e.preventDefault();
    const files = e.target.files;
    if (files.length !== 1) {
      return;
    }

    const file = files[0];
    const reader = new FileReader();
    reader.onload = function (e) {
      const data = new Uint8Array(e.target.result);
      const workbook = XLSX.read(data, { type: 'array' });
      const { PbPResult } = parseExcel({
        workbook,
        errorToast,
        awayTeamPlayers,
        homeTeamPlayers,
      });
      if (!PbPResult) {
        return;
      }

      toast('檔案分析成功！點擊送出進行更新（同時連動打擊/投球/守備位置）', {
        status: 'success',
        second: 3,
      });
      setParsedData(PbPResult);
    };
    reader.readAsArrayBuffer(file);
  };

  const updatePbP = () => {
    const endOutsInt = parseInt(endOuts);
    if (Number.isNaN(endOutsInt) || 0 > endOutsInt || 3 < endOutsInt) {
      errorToast('比賽結束出局數要介於 0 - 3 之間');
      return;
    }

    const BoxScore = getBoxScore({ gameInfo: gameWithPlayers, parsedData, endOuts: endOutsInt, errorToast });
    if (BoxScore === false) {
      return;
    }

    console.log(parsedData);
    console.log(BoxScore);
    setUploading(true);
    updateGamePbP(tournamentInfo.uniqid, gameWithPlayers.uniqid, BoxScore)
      .then((newGameDataWithPlayers) => {
        tournamentDispatch({
          type: 'UPDATE_GAME',
          payload: {
            ...newGameDataWithPlayers,
          },
        });
        toast('更新成功！請至客/主場數據確認', { status: 'success' });
        setParsedData(null);
      })
      .catch((e) => {
        errorToast(`發生錯誤：${e.toString()}，請重新整理後再試一遍`);
      })
      .finally(() => {
        setUploading(false);
      });
  };

  const cleanParsedData = () => {
    setParsedData(null);
  };

  if (
    gameWithPlayers.info.status !== 'FINISHED' ||
    gameWithPlayers.away.runs_without_innings ||
    gameWithPlayers.home.runs_without_innings
  ) {
    return <label>比賽需結束且填完逐局得分</label>;
  }

  return (
    <StyledDiv>
      {!parsedData ? (
        <input type="file" accept=".xlsx,.xls" multiple={false} onChange={handleFileOnChange} key={inputRefresh} />
      ) : (
        <Fragment>
          <label>
            比賽結束當下出局數
            <Input width="unset" value={endOuts} onChange={handleEndOutsChange} />
          </label>
          <Button width="unset" color="red" onClick={updatePbP} disabled={uploading}>
            送出
          </Button>
          <Button width="unset" color="transparentWithBorder" onClick={cleanParsedData} disabled={uploading}>
            取消
          </Button>
        </Fragment>
      )}
    </StyledDiv>
  );
};

export default PbPUpload;
